import { render } from "./auditRecord.vue?vue&type=template&id=04a5ff7f&scoped=true"
import script from "./auditRecord.vue?vue&type=script&lang=js"
export * from "./auditRecord.vue?vue&type=script&lang=js"

import "./auditRecord.vue?vue&type=style&index=0&id=04a5ff7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a5ff7f"]])

export default __exports__